import { render, staticRenderFns } from "./SignInDetails.vue?vue&type=template&id=0223e1f2&scoped=true"
import script from "./SignInDetails.vue?vue&type=script&lang=js"
export * from "./SignInDetails.vue?vue&type=script&lang=js"
import style0 from "./SignInDetails.vue?vue&type=style&index=0&id=0223e1f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223e1f2",
  null
  
)

export default component.exports